import * as React from 'react';

import { translate } from '~l10n/client';

import { ResultsGridCornerMask } from './ResultsGridCornerMask';

interface Props {
  children: React.ReactNode;
}

export function ResultsFooterHeader({ children }: Props): React.ReactElement {
  return (
    <div className="relative flex bg-grey-200 rounded-4px h-full items-center">
      <ResultsGridCornerMask />
      <div className="flex-grow p-0">
        <div className="flex px-4 py-2">
          <div className="flex items-center -ml-4">
            <div className="pl-4">
              <span className="text-sm font-500 leading-8 text-blue-900">
                {children}
              </span>
            </div>
            <div className="pl-4">
              <span className="text-sm font-500 leading-8 text-blue-900 truncate">
                {translate('Class Total')}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className="p-0">
        <div className="px-4 py-2 leading-8">&nbsp;</div>
      </div>
    </div>
  );
}
